@if (mode() === "ADD" || mode() === "RENAME") {
	<div class="text">
		<ng-content></ng-content>
		@if (!entry.secondLineTranslate) {
			<h6>{{ entry.secondLine }}</h6>
		}
		@if (entry.secondLineTranslate) {
			<h6 translate="{{ entry.secondLineTranslate }}"></h6>
		}
	</div>
}
@if (!(mode() === "ADD" || mode() === "RENAME")) {
	<div class="text">
		@if (entry.labelTranslate) {
			<h3 [ngClass]="entry.labelClasses" [translate]="entry.labelTranslate"></h3>
		}
		@if (!entry.labelTranslate) {
			<h3 [ngClass]="entry.labelClasses">{{ entry.label }}</h3>
		}
		@if (!entry.secondLineTranslate) {
			<h6>{{ entry.secondLine }}</h6>
		}
		@if (entry.secondLineTranslate) {
			<h6 translate="{{ entry.secondLineTranslate }}"></h6>
		}
	</div>
	<ng-container />
}
